import { render } from "./userPay.vue?vue&type=template&id=6684cb2f&scoped=true"
import script from "./userPay.vue?vue&type=script&lang=js"
export * from "./userPay.vue?vue&type=script&lang=js"

import "./userPay.vue?vue&type=style&index=0&id=6684cb2f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6684cb2f"]])

export default __exports__